import LegalLayout from "./LegalLayout";

export default function Impressum() {
  return (
    <LegalLayout eyebrow="Rechtliches" title="Impressum">
      <section>
        <h2 className="font-serif-editorial text-3xl mb-4">Angaben gemäss Bundesgesetz gegen den unlauteren Wettbewerb (UWG)</h2>
        <p><strong>Hudak Enterprises</strong><br />
        Sonnrainstrasse 13<br />
        3510 Konolfingen<br />
        Schweiz</p>
      </section>

      <section>
        <h3 className="font-serif-editorial text-2xl mb-3">Kontakt</h3>
        <p>Telefon: +41 77 435 15 61<br />
        E-Mail: mhudak@hudakenterprises.ch<br />
        Web: hudakenterprises.ch</p>
      </section>

      <section>
        <h3 className="font-serif-editorial text-2xl mb-3">Vertretungsberechtigte Person</h3>
        <p>Matej Hudak, Inhaber &amp; CEO</p>
      </section>

      <section>
        <h3 className="font-serif-editorial text-2xl mb-3">Haftungsausschluss</h3>
        <p>Der Autor übernimmt keinerlei Gewähr hinsichtlich der inhaltlichen Richtigkeit, Genauigkeit, Aktualität, Zuverlässigkeit und Vollständigkeit der Informationen. Haftungsansprüche gegen den Autor wegen Schäden materieller oder immaterieller Art, welche aus dem Zugriff oder der Nutzung bzw. Nichtnutzung der veröffentlichten Informationen, durch Missbrauch der Verbindung oder durch technische Störungen entstanden sind, werden ausgeschlossen.</p>
        <p>Alle Angebote sind unverbindlich. Der Autor behält es sich ausdrücklich vor, Teile der Seiten oder das gesamte Angebot ohne gesonderte Ankündigung zu verändern, zu ergänzen, zu löschen oder die Veröffentlichung zeitweise oder endgültig einzustellen.</p>
      </section>

      <section>
        <h3 className="font-serif-editorial text-2xl mb-3">Haftung für Links</h3>
        <p>Verweise und Links auf Webseiten Dritter liegen ausserhalb unseres Verantwortungsbereichs. Es wird jegliche Verantwortung für solche Webseiten abgelehnt. Der Zugriff und die Nutzung solcher Webseiten erfolgt auf eigene Gefahr des jeweiligen Nutzers.</p>
      </section>

      <section>
        <h3 className="font-serif-editorial text-2xl mb-3">Urheberrechte</h3>
        <p>Die Urheber- und alle anderen Rechte an Inhalten, Bildern, Fotos oder anderen Dateien auf dieser Website gehören ausschliesslich Hudak Enterprises oder den speziell genannten Rechteinhabern. Für die Reproduktion jeglicher Elemente ist die schriftliche Zustimmung der Urheberrechtsträger im Voraus einzuholen.</p>
      </section>

      <p className="font-mono-eyebrow text-[#0A0A0A]/50 pt-4">Stand: Dezember 2026</p>
    </LegalLayout>
  );
}
